import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { renameDocument } from '../../../../../api/Services/gedService';

const RenameDocument = ({ show, onHide, item, projectId, fetchFolders }) => {
  const [newName, setNewName] = useState('');

  useEffect(() => {
    if (item) {
      setNewName(item.name);
    }
  }, [item]);

  const handleRenameSubmit = async () => {
    if (newName.trim() === '') return; 
    try {
      await renameDocument(projectId, item.id, newName);
      onHide();
      await fetchFolders();
    } catch (error) {
      console.error('Error renaming document:', error);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Renommer le document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="newDocumentName">
            <Form.Label>Nom du document</Form.Label>
            <Form.Control
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Entrez un nouveau nom"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fermer
        </Button>
        <Button variant="success" onClick={handleRenameSubmit}>
          Renommer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RenameDocument;
